<template>
  <div class="supplier-highWay">
    <div class="nav">
      <el-form :model="searchForm" label-width="85px" :inline="true" class="demo-form-inline flex1">
        <el-form-item label="供应商:">
          <el-input v-model="searchForm.companyName" size="mini" placeholder="请输入供应商" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="标题：">
          <el-input v-model="searchForm.title" size="mini" placeholder="请输入标题" style="width: 200px" />
        </el-form-item>
        <el-form-item label="编号：">
          <el-input v-model="searchForm.number" size="mini" placeholder="请输入编号" />
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <el-button size="small" type="danger" @click="btnClick('delete')">批量删除</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span="24" style="text-align: end; font-size: 14px !important" class="exportButton">
        <span @click="exportData">导出数据</span>
      </el-col>
    </el-row>
    <div class="content">
      <div class="tableContainer">
        <el-table v-loading="tableLoad" :data="TableDatas" style="width: 100%" border ref="multipleTable" row-key="id" @selection-change="selectionChange" :row-style="rowStyle" :reserve-selection="true" :header-cell-style="{ color: '#3B3B3B', 'font-size': '13px', height: '48px', background: '#E8E8E8' }" :cell-style="{ height: '42px' }">
          <el-table-column type="selection" align="center" width="50px" :reserve-selection="true" />
          <el-table-column label="序号" align="center" width="50px" type="index" />
          <el-table-column prop="companyName" label="供应商" align="center" show-overflow-tooltip width="200" />
          <el-table-column prop="title" label="标题" align="center" show-overflow-tooltip width="150" />
          <el-table-column prop="number" label="编号" align="center" width="150" show-overflow-tooltip />
          <el-table-column prop="oilPrice" label="油价费用" align="center" width="150" />
          <el-table-column prop="isReconciliation" label="是否绑定对账单" align="center" width="140">
            <span slot-scope="scope">{{ scope.row.isReconciliation | getIsReconciliation }}</span>
          </el-table-column>
          <el-table-column label="操作" width="530" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="detailClick(scope.row.id, scope.row.companyType)">详情 </el-button>
              <el-button v-if="(scope.row.title === null) & (scope.row.isReconciliation == null)" type="warning" size="mini" @click="addBtn(scope.row, 0)">添加标题 </el-button>
              <el-button v-if="(scope.row.title !== null) & (scope.row.isReconciliation == null)" size="mini" type="success" @click="editBtn(scope.row)">修改标题 </el-button>
              <el-button size="mini" type="danger" @click="btnClick('deleted', scope.row)">删除 </el-button>
              <el-button v-if="scope.row.isReconciliation === null || scope.row.isReconciliation === 0" size="mini" type="primary" @click="referClick(scope.row)">提交对账 </el-button>
              <el-button v-if="scope.row.isReconciliation === 1" size="mini" type="primary" @click="cancelReferClick(scope.row.id)">取消对账 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" :current-page.sync="searchForm.page" :page-size="searchForm.rows" />
      </div>
    </div>
    <!--详情-->
    <oil-details ref="oilDetails" />
    <!--添加/修改-->
    <change-oil ref="changeOil" />
    <!--提交对账-->
    <bill-oil ref="billOil" />
  </div>
</template>

<script>
  import billOil from '@/views/settle/else/components/billOil.vue';
  import changeOil from '@/views/settle/else/components/editOil.vue';
  import OilDetails from '@/views/settle/else/components/oilDetails.vue';
  import { cancelReconciliation, getPage, oilDelete } from '@/service/contract';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';

  export default {
    components: { OilDetails, changeOil, billOil },
    data() {
      return {
        searchForm: {
          companyName: '',
          companyType: 1,
          number: '',
          title: '',
          page: 1,
          size: 10,
        },
        total: 0,
        tableLoad: false,
        TableDatas: [],
        selectedData: [], // 列表选中数据
        ids: {},
      };
    },
    filters: {
      getIsReconciliation(val) {
        switch (val) {
          case 0:
            return '否';
          case 1:
            return '是';
          case null:
            return '否';
        }
      },
    },
    created() {
      this.searchBtn();
    },
    methods: {
      btnClick(str, row) {
        switch (str) {
          case 'delete':
            if (this.selectedData.length === 0) return this.$message.warning('请选择数据后删除！');
            const deleteIds = this.selectedData.map(item => item.id).join(',');
            this.disableClick(deleteIds);
            break;
          case 'deleted':
            this.disableClick(row.id, str);
            break;
        }
      },
      // 查询
      searchBtn() {
        this.page = 1;
        this.getPage();
      },
      // 分页查询
      async getPage() {
        this.tableLoad = true;
        const { status, message, data } = await getPage(this.searchForm);
        this.tableLoad = false;
        if (status !== 0) return this.$message.warning(message);
        this.total = data.total;
        this.TableDatas = data.records;
      },
      // 重置
      resetBtn() {
        this.searchForm.companyName = '';
        this.searchForm.number = '';
        this.searchForm.title = '';
      },

      billCurrentChange(page) {
        this.billData.page = page;
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this.searchBtn();
      },
      contractCurrentChange(page) {
        this.page = page;
        this.expensepaging();
      },
      //详情
      detailClick(id, companyType) {
        this.$refs.oilDetails.dialogOpen(id, companyType);
      },
      // 添加
      addBtn(row) {
        this.$refs.changeOil.dialogOpen(row, 0);
      },
      //修改
      editBtn(row) {
        this.$refs.changeOil.dialogOpen(row);
      },
      //删除
      disableClick(id) {
        this.$confirm('确定要删除当前数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          let res = await oilDelete({ id });
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.clearSelectedData();
        });
      },
      //提交对账
      referClick(row) {
        this.$refs.billOil.dialogOpen(row);
      },
      selectionChange(selection) {
        this.selectedData = selection;
      },
      rowStyle({ row }) {
        return this.selectedData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      //取消对账
      cancelReferClick(id) {
        this.$confirm('确定要取消对账吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await cancelReconciliation(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.searchBtn();
          })
          .catch(() => {});
      },
      //清空列表选中数据
      clearSelectedData() {
        this.$refs.multipleTable.clearSelection();
        this.selectedData = [];
        this.getPage();
      },
      //导出数据
      exportData() {
        let token = getSessionStore('token');
        const ids = this.selectedData.map(item => item.id);
        const idString = ids.join(',');
        window.exportExcel(
          `${baseUrl}/platform/oilPriceCost/export?access_token=${token}`,
          {
            ...this.searchForm,
            id: idString,
          },
          '供应商油价费用',
        );
        this.clearSelectedData();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .supplier-highWay {
    width: 100%;
    /*padding:20px 15px 0 25px;*/
    height: 100%;

    .exportButton {
      span {
        color: rgba(51, 136, 255, 1);
        margin-right: 10px;
        font-size: 14px;

        &:hover {
          cursor: pointer;
        }
      }
    }

    ::v-deep .el-table__header .has-gutter tr .el-table-column--selection .cell .el-checkbox::after {
      color: #606266;
      content: '全选';
      font-size: 12px;
      margin-left: 2px;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      overflow: hidden;

      .navContainer {
        display: inline-block;

        p {
          display: inline-block;
          width: 80px;
          text-align: right;
        }
      }

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      .el-form-item {
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
          line-height: 30px;
        }

        .el-form-item__content {
          line-height: 30px;
        }
      }
    }

    .ledger {
      padding: 20px;

      .leader-input {
        display: inline-block;
        width: 100%;
        margin-bottom: 15px;

        span {
          display: inline-block;
          width: 100px;
        }

        ::v-deep {
          .el-input.el-input--small {
            display: inline-block;
            width: 200px;
          }
        }
      }

      ::v-deep {
        .el-table td {
          padding: 5px;
        }

        .el-table td,
        .el-table th {
          font-size: 13px;
          padding: 5px;
        }
      }
    }

    ::v-deep.content {
      .el-table th > .cell {
        font-weight: 700 !important;
      }

      .el-table .cell,
      .el-table td {
        padding: 0;
      }
    }

    ::v-deep .importBill {
      width: 100%;
      padding: 10px 0 20px 20px;

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      .el-table td,
      .el-table th {
        padding: 0;
      }

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          /*padding:20px 23px 0 23px;*/
          padding-right: 20px;
          margin-top: 20px;
          font-size: 14px;

          .el-table .ui-warning-row {
            background-color: #fef0f0 !important;
          }

          .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover > td {
            background-color: #fef0f0 !important;
          }

          .el-table .ui-warning-row .cell {
            color: red;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }

          .iconError {
            font-size: 15px;

            i:hover {
              color: #00e1ff;
            }
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;
        margin-top: 20px;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;

          .el-button--mini {
            padding: 4px 4px;
          }
        }
      }
    }

    ::v-deep .add {
      font-weight: 700;
      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Input {
          display: flex;
          height: 30px;
          line-height: 30px;
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .el-table td,
          .el-table th {
            padding: 0;
          }

          .iconError {
            font-size: 20px;

            i:hover {
              color: #00e1ff;
            }
          }

          .yang {
            .el-form-item {
              margin-bottom: 15px;

              .el-form-item__label {
                /*width: 150px !important;*/
                /*color: #060606;*/
              }

              .el-input {
                width: 430px;
              }

              .el-textarea {
                width: 250px;
              }
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table td {
        font-size: 13px;
      }

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #ffffff;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }
    }
  }
</style>
